import { Component, Output, EventEmitter, HostListener, ViewChild, Input, ElementRef } from '@angular/core';
import { NavController, NavParams, Events } from 'ionic-angular';
import { SharePage } from '../share/share'
import { DrivePage } from '../drive/drive';
import { TemplateListsPage } from '../../pages/template-lists/template-lists';
import { DriveServiceProvider } from '../../providers/drive-service/drive-service';
import { componentHolderService } from '../../providers/component-holder.service/component-holder.service';
import { ConfigApiServiceProvider } from '../../providers/config-api-service/config-api-service';
import { ConfigureServiceProvider } from '../../providers/configure-service/configure-service';
import { WatchTabViewComponent } from '../../components/watch-tab-view/watch-tab-view';
import { CommunicationServiceProvider } from '../../providers/communication-service/communication-service'


declare var epcConnect: any;
@Component({
  selector: 'page-side-menu',
  templateUrl: 'side-menu.html',
})
export class SideMenuPage {
  @Input() appLoader: any;
  @Input() sharePageActive: boolean = false;
  betsypage: any;
  passData: any;
  cmpt: any;
  title: any;
  showAppsMenuList: boolean = false;
  pages: Array<{ title: string, id: any, component: any, openTab?: any, iconlogo: string, parentfolderid: any, classname: any, display: boolean }>;

  driveApps: Array<{ title: string, iconlogo: string, parentfolderid: any, classname: any }>;
  regUserId: any;
  @Output() pageContainer = new EventEmitter<any>();
  mobileMenuActive: boolean = false;
  mainMenuActive: boolean = true;
  components: any;
  sideShow: boolean = true;
  watchtabNotification: boolean = false;
  broadcastSubs: any;

  constructor(public navCtrl: NavController, public configureAPIService: ConfigApiServiceProvider, public configureService: ConfigureServiceProvider, public configApiService: ConfigApiServiceProvider, public compHolderService: componentHolderService, public navParams: NavParams, public events: Events, public driveService: DriveServiceProvider, public communicationServ: CommunicationServiceProvider) {

    if (window.innerWidth > 700) {
      this.mainMenuActive = true;
    } else {
      this.mainMenuActive = false;
    }

    this.initDriveEvents();

    this.driveService.pages = [
      // { title: 'Desk', component: DeskDashboardPage, iconlogo: "assets/drive/icon_image/desk.svg", parentfolderid: '1', classname: 'active', display: true },
      // { title: 'Shared', component: SharePage, iconlogo: "assets/drive/icon_image/drive.svg", parentfolderid: '2', classname: 'inactive', display: true },
      { title: 'Drive', id: 'Drive', component: DrivePage, iconlogo: "assets/drive/icon_image/drive.svg", parentfolderid: '3', classname: 'active', display: true },
      { title: 'Messages', id: 'message', component: WatchTabViewComponent, iconlogo: "assets/drive/icon_image/messages.svg", parentfolderid: '4', classname: 'inactive', display: true },
      { title: 'Studio', id: 'Templates', component: TemplateListsPage, iconlogo: "assets/drive/icon_image/templateNew.svg", parentfolderid: '5', classname: 'inactive', display: this.driveService.adminAccess || this.driveService.clientAdminAccess },
      // { title: 'Mobile', component: AppBuilderComponent, iconlogo: "assets/drive/icon_image/app.svg", parentfolderid: '6', classname: 'inactive', display: this.driveService.adminAccess },
    ];
    this.pages = this.driveService.pages;
    this.components = this.compHolderService.getComponents();
    console.log(this.components)
    this.driveService.componentList = this.components
  }

  initDriveEvents(){
    this.driveService.broadcastInfo({ src: 'main', event: 'showListView', data: false });

    this.broadcastSubs = this.communicationServ.getInstance()
      .subscribe((data: any) => {
        if (data.src === "main") {
          if (data.event === 'loadPageComponent') {
            var pageIndex = this.pages.find(page => page.title == data['page']);
            if (pageIndex) {
              this.openPage(pageIndex, pageIndex.parentfolderid, pageIndex.component);
            }
          } else if (data.event === 'activepage') {
            if (data['status'] == true) {
              this.activePage(data['status']);
            }
          }
        }

        if (data.src === "loginPage") {
          if (data.event === 'passRegUserId') {
            this.regUserId = data['data'];
          }
        }

        if (data.src === "share") {
          if (data.event === 'selectPageActive') {
            let pageInactive = this.pages.findIndex(x => x.classname == 'active')
            this.pages[pageInactive]['classname'] = "inactive";
            let pageActive = this.pages.findIndex(x => x.title == data['page']);
            this.pages[pageActive]['classname'] = "active";
          }
        }

        if (data.src === "sidePanelShow") {
          if (data.event === 'sideBarShow') {
            this.sideShow = data['status'];
            if (data['status'] == true) {
              this.driveService.broadcastInfo({ src: 'sidePanel', event: 'showPage', data: false });
            } else {
              this.driveService.broadcastInfo({ src: 'sidePanel', event: 'showPage', data: true });
            }
          }
        }

      });
  }
  openPage(page, pf_id, cmpt) {
    if (window.innerWidth < 700) {
      this.mobileMenuActive = !this.mobileMenuActive;
    }
    this.driveService.broadcastInfo({ src: 'main', event: 'headerShow', data: true });

    this.driveService.broadcastInfo({ src: 'sidePanel', event: 'clickedMenuId', data: pf_id });

    let pageActive: any;
    let pageInactive: any;
    this.cmpt = cmpt
    this.driveService.activeSideMenu = page.id;
    pageInactive = this.pages.findIndex(x => x.classname == 'active')
    this.pages[pageInactive]['classname'] = "inactive";
    pageActive = this.pages.findIndex(x => x.title == page.title);
    this.pages[pageActive]['classname'] = "active";
    this.title = page.title
    this.passData = { title: this.title, component: this.cmpt };
    localStorage.setItem('title', this.title);
    this.pageContainer.emit(this.passData);
  }

  mobileMenu() {
    this.mobileMenuActive = !this.mobileMenuActive;
  }

  activePage = ((data) => {

    let title: any;
    let pageActive: any
    title = localStorage.getItem('title');
    let pageInactive: any;
    if (title == null) {
      this.passData = { title: 'Drive', component: DrivePage };
      this.pageContainer.emit(this.passData);
    } else {
      pageInactive = this.pages.findIndex(x => x.classname == 'active')
      this.pages[pageInactive]['classname'] = "inactive";
      pageActive = this.pages.findIndex(x => x.title == title);
      this.pages[pageActive]['classname'] = "active";
      this.passData = { title: this.pages[pageActive]['title'], component: this.pages[pageActive]['component'] };
      this.pageContainer.emit(this.passData);
    }
  });

  ngAfterContentChecked() {
    let activeDesk;
    let pageActive;
    if (this.appLoader) {
      activeDesk = this.pages.findIndex(item => item['component'] == this.appLoader['component'])
      if (activeDesk != -1) {
        pageActive = this.pages.findIndex(item => item['classname'] == "active")
        if (pageActive != -1) {
          this.pages[pageActive]['classname'] = "inactive";
        }
        this.pages[activeDesk]['classname'] = "active";
      }
    } else if (this.sharePageActive) {
      activeDesk = this.pages.findIndex(item => item['component'] == SharePage)
      if (activeDesk != -1) {
        pageActive = this.pages.findIndex(item => item['classname'] == "active")
        if (pageActive != -1) {
          this.pages[pageActive]['classname'] = "inactive";
        }
        this.pages[activeDesk]['classname'] = "active";
      }
    }

  }

  ngOnDestroy() {
  }
}


// WEBPACK FOOTER //
// ./src/pages/side-menu/side-menu.ts